// extracted by mini-css-extract-plugin
export default {"badge":"ListingEndDateBadge_badge__u5x-g","expiring":"ListingEndDateBadge_expiring__2U6lM","expired":"ListingEndDateBadge_expired__x8Hor","icon":"ListingEndDateBadge_icon__tBEb7"};